import styled from 'styled-components';
import { ReactComponent as CriticalAssetTag } from '@elementary/common-ui/assets/16x16/critical-asset-tag.svg';
import { ReactComponent as CloseIcon } from '@elementary/common-ui/assets/close.svg';
import {
  FlexCenter,
  IconButton,
  OverflowTooltip,
} from '@elementary/common-ui/components';

const StyledNotification = styled(FlexCenter)<{ $visible: boolean }>`
  position: absolute;
  top: 0;
  left: -24px;

  width: calc(100% + 48px); // 24px padding on each side

  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  height: ${({ $visible }) => ($visible ? '40px' : '0')};
  transition: all 0.2s ease-in-out;
  background-color: ${({ theme }) => theme.palette.common.green10};
  gap: 8px;

  font-size: 12px;
  color: ${({ theme }) => theme.palette.common.gray20};
  padding: 16px 8px;

  > svg {
    fill: ${({ theme }) => theme.palette.common.green20};
  }
`;

interface CriticalAssetsNotificationProps {
  visible: boolean;
  hasSetPermissions: boolean;
  onClose: () => void;
}

const CriticalAssetsNotification = ({
  visible,
  hasSetPermissions,
  onClose,
}: CriticalAssetsNotificationProps) => (
  <StyledNotification $visible={visible}>
    <FlexCenter>
      <CriticalAssetTag />
    </FlexCenter>
    <OverflowTooltip>
      This asset is marked as critical. Alerts will now highlight any issues
      that may impact this asset or its upstream dependencies.
    </OverflowTooltip>
    {hasSetPermissions && (
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    )}
  </StyledNotification>
);

export default CriticalAssetsNotification;
